export default "__VITE_ASSET__51308627__"